import { BrowserRouter, Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";
import DashboardPage from "./pages/DashboardPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ParkingDetailPage from "./pages/ParkingDetailPage";
import AdminParkingNewPage from "./pages/AdminParkingNewPage";
import AdminVehicleNewPage from "./pages/AdminVehicleNewPage";
import AdminCamerasPage from "./pages/AdminCamerasPage";
import { AuthProvider } from "./providers/AuthProvider";
import { CitySelectionProvider } from "./providers/CitySelectionProvider";
import { useAuth } from "./hooks/useAuth";
import AppShell from "./components/AppShell";

function ProtectedRoute({ requiresAdmin = false }: { requiresAdmin?: boolean }) {
  const { isAuthenticated, isAdmin } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        replace
        state={{
          from: `${location.pathname}${location.search}`,
        }}
      />
    );
  }

  if (requiresAdmin && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/admin/vehicles/new" element={<AdminVehicleNewPage />} />
        </Route>
        <Route element={<ProtectedRoute requiresAdmin />}>
          <Route path="/admin/parking/new" element={<AdminParkingNewPage />} />
          <Route path="/admin/cameras" element={<AdminCamerasPage />} />
        </Route>
        <Route path="/oplac-postoj" element={<Navigate to="/" replace />} />
        <Route path="/parking/:cityId/:spotId" element={<ParkingDetailPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CitySelectionProvider>
          <AppRoutes />
        </CitySelectionProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
